define((require) => {
    "use strict";

    const _                             = require("underscore");
    const ImageLibraryCollectionView    = require("ui/imageLibrary/ImageLibraryCollectionView");
    const ImprovedView                  = require("editor/zbone/ImprovedView");
    const template                      = require("ui/imageLibrary/AbstractImageLibraryView.tpl");

    return ImprovedView.extend("AbstractImageLibraryView", {

        className: "dashboard-image-view",

        template,

        regions: {
            imageLibraryRegion: ".image-library-region"
        },

        /**
         * @type {ImageLibraryCollectionView}
         */
        _imageLibraryView: null,

        /**
         * Exposes the event source (most likely a collection) associated with the number of
         * items represented by  *this* dashboard sub view. The dashboard will use this for updating
         * the counting labels, by listening for relevant events.
         *
         * @return {Collection} The main collection for this dashboard sub view.
         *
         * @see DashboardView#showTab
         */
        getCountableEventSource() {
            return this.options.collection;
        },

        onShow() {
            const ImageLibraryViewClass = this.imageLibraryClass || ImageLibraryCollectionView;
            const imageLibraryViewOptions = _.extend(this.options, {
                itemView: this.itemView,
                itemViewOptions: this._itemViewOptions(),
                hideOverlayDuringLoad: true,
                collectionViewOptions: _.result(this.options, "collectionViewOptions") || this.collectionViewOptions
            });

            this._imageLibraryView = new ImageLibraryViewClass(imageLibraryViewOptions);

            this.imageLibraryRegion.show(this._imageLibraryView);
        },

        /**
         * Invoked from the dashboard view when the tab already exists and we just need to update partial views
         * Implementation example in DashboardImageLibraryView
         */
        updatePartialViews() {
        },

        /**
         * Invoked from the dashboard view when the tab representing this view become active/deactive.
         *
         * @param  {Boolean} active The active state.
         */
        active(active) {
            // Delegate active state to the InfiniteScrollingCollectionView
            // instance - this will enable/disable the scroll listener.
            this._imageLibraryView.active(active);

            if (active) {
                this._imageLibraryView.refresh();
            }
        },

        _itemViewOptions() {
            const own = _.result(this, "itemViewOptions") || {};
            const fromOptions = _.result(this.options, "itemViewOptions") || {};

            const {spectatorMode, imageViewedEventsEnabled, imageLibrarySorting} = this.options;

            return _.extend(own, fromOptions, {
                showTooltips: false,
                showTimesUsedTooltip: true,
                showImageInfo: true,
                showImageViews: imageViewedEventsEnabled,
                dropTargetSize: "large",
                enableDeletion: !spectatorMode,
                isEditable: !spectatorMode,
                imageTaggingEnabled: this.options.imageTaggingEnabled,
                inventoryEnabled: this.options.inventoryEnabled,
                imageLibrarySorting
            });
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/imageLibrary/AbstractImageLibraryView.js